var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quote)?_c('div',{staticClass:"wrapper wrapper-content wrapper-boxed"},[_vm._v(" "+_vm._s(_vm.quote.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }